// EmailJS Configuration
// Add your credentials here

export const EMAILJS_CONFIG = {
  SERVICE_ID: "service_nd3xa6v",
  TEMPLATE_ID: "template_ijuqy0f",
  PUBLIC_KEY: "Pz_lZ2kDYxO3-69BH",
  ADMIN_EMAIL: "abdulhadhi.developer@gmail.com",
};
